import {
  PlanType,
  SubscriptionOptionsType,
  UserSubscribeType,
} from '~/types/subscriptionTypes';
import { appApi } from '~/redux/api/appApiSlice';

export const subscriptionApiSlice = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubscribePlan: builder.query<
      PlanType,
      { id: string | undefined; locale: string }
    >({
      query: ({ id, locale }) => {
        return {
          url: `/api/v2/subscription-plan/${id}`,
          headers: {
            'Accept-Language': locale,
          },
        };
      },
    }),
    getSubscriptionPlans: builder.query<
      PlanType[],
      { userType?: number; locale: string }
    >({
      query: ({ userType, locale }) => {
        return {
          url: `api/v2/subscription-plans${userType ? `?userType=${userType}` : ''}`,
          headers: {
            'Accept-Language': locale,
          },
        };
      },
      providesTags: ['subscriptionPlans'], // Helps with caching
    }),
    getUserSubscription: builder.query<UserSubscribeType, { locale?: string }>({
      query: ({ locale }) => {
        return {
          url: '/api/v2/user/subscription',
          headers: {
            'Accept-Language': locale,
          },
        };
      },
      providesTags: ['userSubscription'], // Helps with caching
    }),

    cancelSurveyOptions: builder.query<SubscriptionOptionsType, number>({
      query: (id) => {
        return {
          url: `/api/v4/user/subscription/${id}/cancel`,
          method: 'GET',
        };
      },
    }),
    cancelSubscription: builder.mutation<
      void,
      { id: number; formData: { reasons: string[]; comment: string } }
    >({
      query: ({ id, formData }) => {
        return {
          url: `/api/v4/user/subscription/${id}/cancel`,

          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (_, error) => (error ? [] : ['userSubscription']),
    }),
    reactivateSubscription: builder.mutation<void, number>({
      query: (id) => {
        return {
          url: `/api/v4/user/subscription/${id}/reactivate`,
          method: 'POST',
        };
      },
      invalidatesTags: (_, error) => (error ? [] : ['userSubscription']),
    }),
  }),
});

export const {
  useGetSubscribePlanQuery,
  useGetSubscriptionPlansQuery,
  useGetUserSubscriptionQuery,
  useCancelSubscriptionMutation,
  useReactivateSubscriptionMutation,
  useLazyCancelSurveyOptionsQuery,
} = subscriptionApiSlice;
